import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { titleize } from 'inflect';

import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';

import Fetchable from '~/commons/components/util/Fetchable';

import Page from '../../layout/Page';

const PageRankings = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <Fetchable
        req={[
          { url: '/api/users/self' },
          {
            url: '/api/rankings',
            params: {
              limit: 100,
              sort: { rank: 1, ansTime: 1, username: 1 },
            },
          }]}
      >
        {([user, { rows: rankings }]) => (
          <div className="container">
            <div>
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  {/* header */}
                  <div className="position-relative text-center my-4">
                    <img
                      src="/assets/img/ribbon.png"
                      alt=""
                      style={{ width: '20%', minWidth: '5rem' }}
                    />
                    <h1 className="d-inline align-middle px-3 px-md-5 fw-bold">
                      {t('pg.game.rankings')}
                    </h1>
                    <img
                      src="/assets/img/ribbon.png"
                      alt=""
                      style={{ width: '20%', minWidth: '5rem' }}
                    />
                    <Link
                      to="rules"
                      className={`
                        position-absolute end-0 top-50 translate-middle-y
                        fs-3
                      `}
                    >
                      <FA icon={faInfoCircle} />
                    </Link>
                  </div>

                  {/* list */}
                  <div className="row g-4">
                    {rankings.map((r) => (
                      <div key={r._id} className="col-lg-6">
                        <div className="px-3 px-md-5 py-2">
                          <div className="row align-items-center">
                            <div className="col-auto pe-0 fw-bold fs-5">
                              {r.rank + 1}
                            </div>
                            <div className="col-auto position-relative">
                              {r.user === user._id && (
                              <div
                                className="rounded-circle position-absolute blurCircle"
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  boxShadow: '0 0 10px 10px #ffffff',
                                  left: '36.5px',
                                  top: '25px',
                                }}
                              />
                              )}
                              <svg
                                id="svgBox"
                                width="100px"
                                height="100px"
                                viewBox="0 0 100 100"
                              >
                                <defs>
                                  <clipPath id="circleView">
                                    <circle
                                      cx="48"
                                      cy="48"
                                      r="48"
                                      fill="none"
                                      stroke="#FF62E1"
                                      strokeWidth="0"
                                    />
                                  </clipPath>
                                </defs>
                                <image
                                  href={`/assets/img/${
                                    ['gold', 'silver', 'bronze'][r.rank]
                                    || 'copper'
                                  }.png`}
                                  alt="metal"
                                  clipPath="url(#circleView)"
                                  width="60"
                                  height="60"
                                  x="20"
                                  y="20"
                                  style={{ maxWidth: '5rem' }}
                                />
                                <circle
                                  cx="50"
                                  cy="50"
                                  r="30"
                                  className={r.user === user._id ? 'styled-circle active anim-clock' : 'styled-circle'}
                                />

                              </svg>
                              {/* <img
                                src={`/assets/img/${
                                  ["gold", "silver", "bronze"][r.rank] ||
                                  "copper"
                                }.png`}
                                alt="metal"
                                style={{ width: "13vw", maxWidth: "5rem" }}
                              /> */}
                            </div>
                            <div className="col">
                              <div className="mb-1">
                                {t('pg.game.playerName')}
                              </div>
                              <div className="fw-bold fs-5 text-truncate">
                                {r.username}
                              </div>
                            </div>
                            <div className="col-auto">
                              <div className="mb-1">{titleize(t('score'))}</div>
                              <div className="fw-bold fs-5">{r.score}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Fetchable>
    </Page>
  );
};

export default PageRankings;
